let url = `${process.env.REACT_APP_API_URL}`;
let proxyServer = `${process.env.REACT_APP_MUSICMIND_PROXY_SERVER}`;

const login = async (data) => {
  const formData = new FormData();
  formData.append('username', data.username);
  formData.append('password', data.password);

  const loginUrl = `${proxyServer}/${url}api/token/obtain/`;

  return await fetch(loginUrl, {
    method: 'POST',
    body: formData
  })
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

const instoreMusiclogin = async (data) => {
  const formData = new FormData();
  formData.append('username', data.username);
  formData.append('password', data.password);

  const loginUrl = `${proxyServer}/${url}api/token/obtain/`;

  return await fetch(loginUrl, {
    method: 'POST',
    body: formData
  })
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

const signup = async (data) => {
  const formData = new FormData();
  formData.append('email', data.email);
  formData.append('password', data.password);

  const signupUrl = `${proxyServer}/${url}api/user/create/instoremusic`;

  return await fetch(signupUrl, {
    method: 'POST',
    body: formData
  })
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

const obtainBearerNetwork = async (token, data) => {
  const formData = new FormData();
  formData.append('username', data.username);
  formData.append('password', data.password);

  const loginUrl = `${proxyServer}/${url}instorex/obtain-bearer-network/`;

  return await fetch(loginUrl, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

const obtainBearerToken = async (token, data) => {
  const formData = new FormData();
  formData.append('username', data.username);
  formData.append('password', data.password);

  const loginUrl = `${proxyServer}/${url}instorex/obtain-bearer-token/`;

  return await fetch(loginUrl, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(user => {
    return user;
  });
}

const contactSales = async (data) => {
  const formData = new FormData();
  formData.append('email', data.email);
  formData.append('first_name', data.first_name);
  formData.append('last_name', data.last_name);
  formData.append('company', data.company);
  formData.append('message', data.message);
  formData.append('inquiry', data.inquiry);

  const contactSupportUrl = `${proxyServer}/${url}instorex/contact/`;

  return await fetch(contactSupportUrl, {
    method: 'POST',
    body: formData,
  })
  .then(handleResponse)
  .then(data => {
    return data;
  });
}

const logout = async (data) => {
  const formData = new FormData();
  formData.append('refresh_token', data);

  const logoutUrl = url + 'api/blacklist/';

  return await fetch(logoutUrl, {
    method: 'POST',
    body: formData
  })
  .then(handleResponse)
  .then(user => {
    return user;
  })
}

const handleResponse = async response => {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
          // auto logout if 401 response returned from api
          // logout();
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

export const userService = {
  login,
  logout,
  obtainBearerNetwork,
  obtainBearerToken,
  contactSales,
  signup,
  instoreMusiclogin
}